<template>
  <div id="wizardComponent">
    <v-dialog
    v-model="dialog"
    width="90%"
    persistent
    >
      <v-card>
        <form-wizard
          title="Started Wizard"
          subtitle=""
          color="var(--info)"
          @on-complete="onComplete"
          next-button-text="Continuar"
          back-button-text="Regresar"
          finish-button-text="Finalizar"
          stepSize="md"
        >
          <h1 slot="title" class="info--text my-0">Asistente de configuración inicial</h1>
          <tab-content title="¡Bienvenida!" icon="lnr-star">
            <v-container>
              <v-layout class="mb-5">
                <v-flex>
                  <h1 class="text-sm-center font-weight-black info--text">¡Bienvenido a Bluespend!</h1>
                  <v-layout justify-center>
                    <v-icon class="my-3" style="font-size:100px" color="info">lnr-star</v-icon>
                  </v-layout>
                  <br>
                  <h3 class="text-sm-center">Antes de poder continuar, es necesario configurar algunas opciones para que tu experiencia en la aplicación vaya sin ningún problema.</h3>
                  <h3 class="text-sm-center">Sigue los siguientes pasos y complementa la información necesaria.</h3>
                </v-flex>
              </v-layout>
            </v-container>
          </tab-content>
          <tab-content title="Sucursales" icon="lnr-store">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 class="mb-4">
                  <h1 class="text-sm-center info--text font-weight-black">Configuración de Sucursales</h1>
                  <h3 class="text-sm-center">Su empresa ha sido configurada con una sucursal matriz por defecto.</h3>
                  <h3 class="text-sm-center">Presione el botón "Agregar sucursal" si desea agregar una sucursal adicional o presione el ícono del lapiz para editar la información por defecto.</h3>
                  <h3 class="text-sm-center">Si no desea hacer ningún cambio, presione en "Continuar" para ir al siguiente paso.</h3>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    :headers="headersB"
                    :items="branches"
                    class="elevation-1"
                    :rows-per-page-items="[10,15,25]"
                    :pagination.sync="pagination"
                  >
                    <template v-slot:headers="props">
                      <tr class="bg-light">
                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                          @click="changeSort(header)"
                          >
                          <h2 class="font-weight-black info--text mb-0">
                            <v-icon small class="info--text" v-if="header.sortable">arrow_upward</v-icon>
                            {{ header.text }}
                          </h2>
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr>
                        <td width="60px">{{props.index + 1}}</td>
                        <td class="text-sm-center">{{props.item.branch_name}}</td>
                        <td class="text-sm-center">{{props.item.street}}</td>
                        <td class="text-sm-center">{{props.item.city}}</td>
                        <td class="text-sm-center">{{props.item.state}}</td>
                        <td class="text-sm-center">{{props.item.country.descripcion}}</td>
                        <td class="text-sm-center">{{props.item.zip_code}}</td>
                        <td class="text-sm-center">
                          <v-btn icon outline round small color="info" @click="editBranch(props.item)"><v-icon small>edit</v-icon></v-btn>
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data" class="text-sm-center">
                      <v-layout justify-center>
                        <v-btn icon :disabled="true" :loading="true"></v-btn>
                      </v-layout>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="text-xl-right mt-2">
                  <v-btn outline round color="info" @click="branchDialog = true">{{$t('branch.add')}}</v-btn>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-layout row wrap>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </tab-content>
          <tab-content title="Áreas" icon="lnr-apartment">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 class="mb-4">
                  <h1 class="text-sm-center info--text font-weight-black">Configuración de Áreas</h1>
                  <h3 class="text-sm-center">Su empresa ha sido configurada con un área por defecto.</h3>
                  <h3 class="text-sm-center">Presione el botón "Agregar área" si desea agregar un área adicional o presione el ícono del lapiz para editar la información por defecto.</h3>
                  <h3 class="text-sm-center">Si no desea hacer ningún cambio, presione en "Continuar" para ir al siguiente paso.</h3>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    :headers="headersA"
                    :items="areas"
                    class="elevation-1"
                    :rows-per-page-items="[10,15,25]"
                    :pagination.sync="pagination"
                  >
                    <template v-slot:headers="props">
                      <tr class="bg-light">
                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                          @click="changeSort(header)"
                          >
                          <h2 class="font-weight-black info--text mb-0">
                            <v-icon small class="info--text" v-if="header.sortable">arrow_upward</v-icon>
                            {{ header.text }}
                          </h2>
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr>
                        <td width="60px">{{props.index + 1}}</td>
                        <td class="text-sm-center">{{props.item.name}}</td>
                        <td class="text-sm-center">
                          <v-btn icon outline round small color="info" @click="editArea(props.item)"><v-icon small>edit</v-icon></v-btn>
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data" class="text-sm-center">
                      <v-layout justify-center>
                        <v-btn icon :disabled="true" :loading="true"></v-btn>
                      </v-layout>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="text-xl-right mt-2">
                  <v-btn outline round color="info" @click="areaDialog = true">{{$t('area.add')}}</v-btn>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-layout row wrap>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </tab-content>
          <tab-content title="Proyectos" icon="lnr-construction">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 class="mb-4">
                  <h1 class="text-sm-center info--text font-weight-black">Configuración de Proyecto</h1>
                  <h3 class="text-sm-center">Su empresa ha sido configurada con un proyecto por defecto.</h3>
                  <h3 class="text-sm-center">Presione el botón "Agregar proyecto" si desea agregar un proyecto adicional o presione el ícono del lapiz para editar la información por defecto.</h3>
                  <h3 class="text-sm-center">Si no desea hacer ningún cambio, presione en "Continuar" para ir al siguiente paso.</h3>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    :headers="headersP"
                    :items="projects"
                    class="elevation-1"
                    :rows-per-page-items="[10,15,25]"
                    :pagination.sync="pagination"
                  >
                    <template v-slot:headers="props">
                      <tr class="bg-light">
                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                          @click="changeSort(header)"
                          >
                          <h2 class="font-weight-black info--text mb-0">
                            <v-icon small class="info--text" v-if="header.sortable">arrow_upward</v-icon>
                            {{ header.text }}
                          </h2>
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr>
                        <td width="60px">{{props.index + 1}}</td>
                        <td class="text-sm-center">{{props.item.name}}</td>
                        <td class="text-sm-center">
                          <v-btn icon outline round small color="info" @click="editProject(props.item)"><v-icon small>edit</v-icon></v-btn>
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data" class="text-sm-center">
                      <v-layout justify-center>
                        <v-btn icon :disabled="true" :loading="true"></v-btn>
                      </v-layout>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="text-xl-right mt-2">
                  <v-btn outline round color="info" @click="projectDialog = true">{{$t('project.add')}}</v-btn>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-layout row wrap>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </tab-content>
          <tab-content title="Categorías" icon="lnr-tag">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 class="mb-4">
                  <h1 class="text-sm-center info--text font-weight-black">Configuración de Categoría</h1>
                  <h3 class="text-sm-center">Para que su empresa pueda hacer uso de la carga de archivos XML de forma adecuada, es necesario que defina una categoría como predeterminada</h3>
                  <h3 class="text-sm-center">Es posible cargar ciertas Categorías predeterminadas presionando el botón <span class="font-weight-black info--text">"Cargar categorías predeterminadas"</span></h3>
                  <h3 class="text-sm-center">Presione el botón <span class="font-weight-black info--text">"Agregar Categoría"</span> si desea agregar una categoría personalizada.</h3>
                  <h3 class="text-sm-center">Cuando haya terminado, presione en <span class="font-weight-black info--text">"Continuar"</span> para ir al siguiente paso.</h3>
                </v-flex>
                <v-flex v-if="noDefault">
                  <b-alert :show="noDefault" variant="warning">
                    <v-layout class="align-center">
                      <v-flex class="mr-3">
                        <v-icon class="alert-link">fa-exclamation-triangle</v-icon>
                        <!-- <h3><i class="fas fa-exclamation-triangle"></i></h3> -->
                      </v-flex>
                      <v-flex>
                        <h3 class="text-sm-justify"> {{$t('categories.warning')}}</h3>
                      </v-flex>
                    </v-layout>
                  </b-alert>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    :headers="headersC"
                    :items="categories"
                    class="elevation-1"
                    :rows-per-page-items="[10,15,25]"
                    :pagination.sync="pagination"
                  >
                    <template v-slot:headers="props">
                      <tr class="bg-light">
                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                          @click="changeSort(header)"
                          >
                          <h2 class="font-weight-black info--text mb-0">
                            <v-icon small class="info--text" v-if="header.sortable">arrow_upward</v-icon>
                            {{ header.text }}
                          </h2>
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr>
                        <td width="60px">{{props.item.id}}</td>
                        <td class="text-sm-center"><v-icon style="vertical-align: middle" v-if="props.item.default === 1" class="info--text">stars</v-icon> {{props.item.name}}</td>
                        <td width="200px">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                small
                                outline
                                icon
                                color="info"
                                v-on="on"
                                @click="editCategory(props.item)"
                              >
                                <v-icon small>edit</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('general.edit') }}</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="text-xl-right mt-2">
                  <v-btn outline round color="info" @click="categoryDialog = true">{{$t('categories.add')}}</v-btn>
                  <v-btn :disabled="defaultsLoaded" outline round color="info" @click="confirmCategoryDialog = true">{{$t('categories.loadDefault')}}</v-btn>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-layout row wrap>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </tab-content>
          <tab-content title="Ajustes" icon="lnr-calendar-full" :before-change="getUsers">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 class="mb-4">
                  <h1 class="text-sm-center info--text font-weight-black">{{ $t('wizard.period.title') }}</h1>
                  <h3 class="text-sm-center">{{ $t('wizard.period.text')}}</h3>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    :items="companySettings"
                    :headers="headersPeriod"
                    class="elevation-1"
                    :rows-per-page-items="[10,15,25]"
                    :pagination.sync="pagination"
                    >
                      <template v-slot:headers="props">
                        <tr class="bg-light">
                          <th
                            v-for="header in props.headers"
                            :key="header.text"
                            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc',header.value === pagination.sortBy ? 'active': '']"
                            @click="changeSort(header)"
                            >
                              <h2 class="font-weight-black info--text mb-0">
                                <v-icon small class='info--text' v-if="header.sortable">arrow_upward</v-icon>
                                {{ header.text }}
                              </h2>
                            </th>
                        </tr>
                      </template>
                      <template v-slot:items="props">
                      <tr>
                        <td width="60px">{{props.item.id}}</td>
                        <td class="text-sm-center">{{$t('setting.' + props.item.setting_type.name)}}</td>
                        <td class="text-sm-center" v-if="props.item.gst_setting_type_id === 1">
                          <v-layout>
                            <v-flex xs6>
                              <strong>{{$t('setting.periodType')}}:</strong>
                              <b-badge pill variant="primary">
                                {{$t('setting.' + getPeriodType(props.item.value.periodType))}}
                              </b-badge>
                            </v-flex>
                            <v-flex xs6>
                              <strong>{{$t('setting.deadline')}}:</strong>
                              <b-badge v-if="props.item.value.periodType === 1" pill variant="primary">
                                {{getWeekDay(props.item.value.deadline)}}
                              </b-badge>
                              <b-badge v-else pill variant="primary">
                                {{props.item.value.deadline}}
                              </b-badge>
                            </v-flex>
                          </v-layout>
                        </td>
                        <td class="text-sm-center" v-if="props.item.gst_setting_type_id === 2">
                          <v-layout>
                            <v-flex xs6>
                              <strong>CFDI (XML)</strong>
                              <b-badge pill variant="primary">
                                {{props.item.value.fiscal.comment_required ? $t('general.yes') : $t('general.no')}}
                              </b-badge>
                            </v-flex>
                            <v-flex xs6>
                              <strong>{{$t('general.receipt')}}</strong>
                              <b-badge pill variant="primary">
                                {{props.item.value.no_fiscal.comment_required ? $t('general.yes') : $t('general.no')}}
                              </b-badge>
                            </v-flex>
                          </v-layout>
                        </td>
                        <td width="200px">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                outline
                                icon
                                color="info"
                                v-on="on"
                                @click="editedPeriod(props.item)"
                              >
                                <v-icon small>edit</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('general.edit') }}</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="text-xl-right mt-2">
                  <v-btn outline round color="info" @click="periodDialog = true">{{$t('setting.add')}}</v-btn>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-layout row wrap></v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </tab-content>
          <tab-content title="Usuarios" icon="lnr-users">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 class="mb-4">
                  <h1 class="text-sm-center info--text font-weight-black">Configuración de Usuarios</h1>
                  <h3 class="text-sm-center">En este paso puedes comenzar a crear los primeros usuarios que utilizarán el sistema.</h3>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    :headers="headersU"
                    :items="users"
                    class="elevation-1"
                    :rows-per-page-items="[10,15,25]"
                    :pagination.sync="pagination"
                  >
                    <template v-slot:headers="props">
                      <tr class="bg-light">
                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                          @click="changeSort(header)"
                          >
                          <h2 class="font-weight-black info--text mb-0">
                            <v-icon small class="info--text" v-if="header.sortable">arrow_upward</v-icon>
                            {{ header.text }}
                          </h2>
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr>
                        <td width="60px">{{props.index + 1}}</td>
                        <td class="text-sm-center">{{props.item.name}}</td>
                        <td class="text-xs-center">{{ props.item.email }}</td>
                        <td class="text-xs-center">{{ props.item.roles[0] ? props.item.roles[0].name : '' }}</td>
                        <td class="text-sm-center">
                          <v-btn icon outline round small color="info" @click="editUser(props.item)"><v-icon small>edit</v-icon></v-btn>
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data" class="text-sm-center">
                      <v-layout justify-center>
                        <v-btn icon :disabled="true" :loading="true"></v-btn>
                      </v-layout>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 class="text-xl-right mt-2">
                  <v-btn outline round color="info" @click="userDialog = true">{{$t('user.add')}}</v-btn>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-layout row wrap>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </tab-content>
          <tab-content title="¡Finalizado!" icon="lnr-checkmark-circle">
            <v-container>
              <v-layout class="mb-5">
                <v-flex>
                  <h1 class="text-sm-center font-weight-black info--text">¡Configuración terminada!</h1>
                  <v-layout justify-center>
                    <v-icon class="my-3" style="font-size:100px" color="info">lnr-checkmark-circle</v-icon>
                  </v-layout>
                  <br>
                  <h3 class="text-sm-center">A partir de ahora ya podrás comenzar a utilizar Bluespend para administrar tus gastos.</h3>
                </v-flex>
              </v-layout>
            </v-container>
          </tab-content>
        </form-wizard>
      </v-card>
    </v-dialog>
    <!-- Branches dialog add/edit -->
    <v-dialog
      v-model="branchDialog"
      scrollable
      persistent
      width="50%"
    >
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black info--text mb-0">{{branchTitle}}</h2>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xl>
            <v-form
              ref="branchForm"
              v-model="branchValid"
              lazy-validation
            >
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    clearable
                    required
                    :rules="rules.textRules"
                    :label="$t('general.name')"
                    :error-messages="errors.branch_name"
                    v-model="editedBranch.branch_name"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    clearable
                    required
                    :rules="rules.textRules"
                    :label="$t('address.street')"
                    :error-messages="errors.street"
                    v-model="editedBranch.street"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    clearable
                    required
                    :rules="rules.textRules"
                    :label="$t('address.city')"
                    :error-messages="errors.city"
                    v-model="editedBranch.city"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    clearable
                    required
                    :rules="rules.textRules"
                    :label="$t('address.state')"
                    :error-messages="errors.state"
                    v-model="editedBranch.state"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete
                    required
                    :items="items"
                    item-value="id"
                    item-text="descripcion"
                    :search-input.sync="searchB"
                    :filter="dataArrayFilter.filter"
                    :rules="rules.required"
                    :error-messages="errors.country"
                    class="mr-3"
                    :label="$t('address.country')"
                    v-model="editedBranch.sat_pais_id"
                    cache-items
                    flat
                    hide-details
                    >
                      <template slot="selection" slot-scope="data">
                        {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                      </template>
                      <template slot="item" slot-scope="data">
                        {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                      </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    clearable
                    required
                    mask="#####"
                    :rules="rules.zipRules"
                    :label="$t('address.zip')"
                    :error-messages="errors.zip_code"
                    v-model="editedBranch.zip_code"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outline
            round
            color="info"
            @click="closeBranch"
          >{{$t('general.cancel')}}</v-btn>
          <v-btn
            :loading="loading"
            :disabled="loading"
            depressed
            round
            color="info"
            @click="saveBranch"
          >{{$t('general.save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Areas dialog add/edit -->
    <v-dialog
      v-model="areaDialog"
      scrollable
      persistent
      width="50%"
    >
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black info--text mb-0">{{areaTitle}}</h2>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xl>
            <v-form
              ref="areaForm"
              v-model="areaValid"
              lazy-validation
            >
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    clearable
                    required
                    :rules="rules.textRules"
                    :label="$t('general.name')"
                    :error-messages="errors.branch_name"
                    v-model="editedArea.name"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          outline
          round
          color="info"
          @click="closeArea"
        >{{$t('general.cancel')}}</v-btn>
          <v-btn
          :loading="loading"
          :disabled="loading"
          depressed
          round
          color="info"
          @click="saveArea">
        {{$t('general.save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Projects dialog add/edit -->
    <v-dialog
      v-model="projectDialog"
      scrollable
      persistent
      width="50%"
    >
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black info--text mb-0">{{projectTitle}}</h2>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xl>
            <v-form
              ref="projectForm"
              v-model="projectValid"
              lazy-validation
            >
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    clearable
                    required
                    :rules="rules.textRules"
                    :label="$t('general.name')"
                    :error-messages="errors.branch_name"
                    v-model="editedProject.name"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outline
            round
            color="info"
            @click="closeProject"
          >{{$t('general.cancel')}}</v-btn>
          <v-btn
            :loading="loading"
            :disabled="loading"
            depressed
            round
            color="info"
            @click="saveProject"
          >{{$t('general.save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Projects dialog add/edit -->
    <v-dialog
      v-model="userDialog"
      scrollable
      persistent
      width="50%"
    >
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black info--text mb-0">{{userTitle}}</h2>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xl>
            <v-form
              ref="userForm"
              v-model="userValid"
              lazy-validation
            >
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedUser.name"
                    :rules="rules.minNameUser"
                    :error-messages="errors.name"
                    :label="$t('general.name')">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedUser.email"
                    :rules="rules.email"
                    :error-messages="errors.email"
                    :disabled="this.userIndex > -1"
                    :label="$t('general.email')">
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedUser.password"
                    :rules="rules.password"
                    :label="$t('login.password')"
                    v-if="isNewItem"
                    :append-icon="showPass ? 'visibility_off' : 'visibility'"
                    :type="showPass ? 'text' : 'password'"
                    :error-messages="errors.password"
                    @click:append="showPass = !showPass">
                  </v-text-field>
                  <v-text-field
                    v-model="editedUser.password"
                    :label="$t('login.password')"
                    v-if="editedUser"
                    :append-icon="showPass ? 'visibility_off' : 'visibility'"
                    :type="showPass ? 'text' : 'password'"
                    :error-messages="errors.password"
                    @click:append="showPass = !showPass">
                  </v-text-field>
                </v-flex>
                <v-layout xs12 v-if="editedUser.user_info" row wrap>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedUser.user_info.phone"
                      :label="$t('taxFields.phone')"
                      :error-messages="errors.phone"
                      :rules="rules.required && rules.digits && rules.phoneRules"
                      mask="###-###-####"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedUser.user_info.address"
                      :label="$t('address.name')"
                      :error-messages="errors.address"
                      :rules="rules.required && rules.minChars">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                    required
                    :items="items"
                    item-value="id"
                    item-text="descripcion"
                    :rules="rules.required"
                    :error-messages="errors.country"
                    class="mr-3"
                    :label="$t('address.country')"
                    v-model="editedUser.user_info.sat_pais_id"
                    :search-input.sync="searchU"
                    :filter="dataArrayFilter.filter"
                    cache-items
                    flat
                    hide-details
                    >
                    <template slot="selection" slot-scope="data">
                        {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                    </template>
                    <template slot="item" slot-scope="data">
                        {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                    </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex sm12>
                    <span>Avatar:</span>
                    <v-img
                      v-if="avatarUrl"
                      :src="avatarUrl"
                      height="200"
                      contain
                      class="mb-2">
                    </v-img>
                    <vue-dropzone
                      ref="dropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                      v-on:vdropzone-file-added="fileAdded"
                      v-on:vdropzone-error="fileUploadError"
                      v-on:vdropzone-success="fileUpload">
                    </vue-dropzone>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-radio-group
                      :label="$t('user.gender')"
                      row
                      :error-messages="errors.gender"
                      :rules="rules.required"
                      v-model="editedUser.user_info.gender">
                      <v-radio color="primary" :label="$t('user.male')" value="male"></v-radio>
                      <v-radio color="primary" :label="$t('user.female')" value="female"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="editedUser.user_info.birthdate"
                          :label="$t('user.birthDate')"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          :error-messages="errors.birthdate"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :locale="$t('general.locale')"
                        v-model="editedUser.user_info.birthdate"
                        color="primary"
                        @input="menu = false"
                        :max="new Date().toISOString().substr(0, 10)"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-flex xs12 md6>
                  <v-select
                    v-model="editedUser.roles[0]"
                    :label="$t('role.name')"
                    :items="rolFilter"
                    item-text="name"
                    :rules="rules.required"
                    return-object></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    v-model="editedUser.area[0]"
                    :label="$t('area.name')"
                    :items="areas"
                    item-text="name"
                    :rules="rules.required"
                    return-object></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    v-model="editedUser.user_info.branch_id"
                    :label="$t('branch.name')"
                    :items="branches"
                    item-text="branch_name"
                    item-value="id"
                    :rules="rules.required"></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    v-model="editedUser.application"
                    :label="$t('general.application')"
                    :items="applications"
                    item-text="name"
                    return-object
                    :rules="rules.required"></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outline
            round
            color="info"
            @click="closeUser"
          >{{$t('general.cancel')}}</v-btn>
          <v-btn
            :loading="loading"
            :disabled="loading"
            depressed
            round
            color="info"
            @click="saveUser"
          >{{$t('general.save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Categories Dialog Add/Edit -->
    <v-dialog persistent v-model="categoryDialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          round
          outline
          v-on="on"
        >
          <v-icon left>category</v-icon>
          {{ $t('categories.add') }}
        </v-btn>
      </template>
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black info--text mb-0">{{categoryTitle}}</h2>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xs>
            <v-form
              lazy-validation
              ref="categoryForm"
              v-model="categoryValid"
            >
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      clearable
                      required
                      :rules="rules.textRules"
                      prepend-icon="edit"
                      :label="$t('categories.description')"
                      :error-messages="errors.name"
                      v-model="editedCategory.name"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 class="text-sm-right">
                    <v-checkbox
                      color="info"
                      v-model="editedCategory.default"
                      :label="$t('categories.setDefault')"
                      :value="1"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="info darken-1"
            round
            flat
            @click="closeCategory"
          >
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn
            :loading="loading"
            :disabled="loading"
            color="info"
            round
            depressed
            @click="saveCategory"
          >
            {{ $t('general.submit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Period Dialog Add/Edit -->
    <v-dialog
      persistent
      v-model="periodDialog"
      max-width="600px"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            round
            outline
            v-on="on"
            >
            <v-icon left>settings</v-icon>
            {{ $t('setting.add') }}
          </v-btn>
        </template>
        <v-card>
          <v-toolbar flat>
          <h2 class="font-weight-black info--text mb-0">{{formTitle}}</h2>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-form
                lazy-validation
                ref="form"
                v-model="valid">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select
                      required
                      :disabled="editedIndexPeriod !== -1"
                      :rules="rules.required"
                      :items="settingType"
                      item-text="name"
                      item-value="id"
                      :label="$t('setting.type')"
                      :error-messages="errors.type"
                      v-model="editedItemPeriod.gst_setting_type_id">
                      <template slot="selection" slot-scope="data">
                        {{ $t('setting.' + data.item.name)}}
                      </template>
                      <template slot="item" slot-scope="data">
                        {{ $t('setting.' + data.item.name)}}
                      </template>
                    </v-select>
                  </v-flex>
                     <v-flex v-if="editedItemPeriod.gst_setting_type_id === 1" xs12>
                        <v-select
                          required
                          :rules="rules.required"
                          :items="periodsType"
                          item-text="name"
                          item-value="id"
                          :label="$t('setting.selectPeriodType')"
                          :error-messages="errors.type"
                          v-model="editedItemPeriod.value.periodType">
                          <template slot="selection" slot-scope="data">
                            {{ $t('setting.' + data.item.name)}}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ $t('setting.' + data.item.name)}}
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex v-if="editedItemPeriod.gst_setting_type_id === 1" xs12>
                        <v-select
                          required
                          :rules="rules.required"
                          :items="days"
                          item-text="name"
                          item-value="id"
                          :label="periodLabel"
                          :error-messages="errors.type"
                          v-model="editedItemPeriod.value.deadline">
                        </v-select>
                      </v-flex>
                      <v-flex v-if="editedItemPeriod.gst_setting_type_id === 2" xs12>
                        <h3>{{$t('setting.requiredComment')}}:</h3>
                          <v-checkbox v-model="editedItemPeriod.value_expenseComment.fiscal.comment_required" :label="`CFDI (XML)`"></v-checkbox>
                          <v-checkbox v-model="editedItemPeriod.value_expenseComment.no_fiscal.comment_required" :label="$t('general.receipt')"></v-checkbox>
                      </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            color="info darken-1"
            round
            flat
            @click="close">
            {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
            :loading="loading"
            :disabled="loading"
            color="info"
            round
            depressed
            @click="savePeriod">
              {{ $t('general.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog persistent v-model="confirmCategoryDialog" max-width="600px">
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black info--text mb-0">{{ $t('categories.loadDefault') }}</h2>
        </v-toolbar>
        <v-card-text class="text-sm-justify">
          <p>{{ $t('categories.confirmDefault') }}:</p>
          <ul class="info--text font-weight-black">
            <li>Combustible</li>
            <li>Alimentos</li>
            <li>Hotel</li>
            <li>Casetas</li>
            <li>Transportes</li>
            <li>Otros</li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="info darken-1"
            round
            flat
            @click="confirmCategoryDialog = false"
          >
            {{ $t('general.close') }}
          </v-btn>
          <v-btn
            :loading="loading"
            :disabled="loading"
            color="info"
            round
            depressed
            @click="setCategoriesDefault()"
          >
            {{ $t('general.accept') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import vue2Dropzone from 'vue2-dropzone'
export default {
  name: 'wizardComponent',
  components: {
    FormWizard,
    TabContent,
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      noDefault: false,
      showPass: false,
      menu: false,
      dialog: true,
      branchDialog: false,
      branchValid: true,
      areaDialog: false,
      areaValid: true,
      projectDialog: false,
      projectValid: true,
      userDialog: false,
      userValid: true,
      categoryDialog: false,
      categoryValid: true,
      confirmCategoryDialog: false,
      defaultsLoaded: false,
      loading: false,
      heading: 'Forms Wizard',
      subheading: 'Easily create beautiful form multi step wizards!',
      icon: 'lnr-map text-info',
      avatarUrl: null,
      avatarID: null,
      userLogged: {},
      searchU: '',
      searchB: '',
      items: [],
      satPais: [],
      branches: [],
      branchesByCompany: {
        branch: []
      },
      users: [],
      roles: [],
      areas: [],
      projects: [],
      categories: [],
      applications: [],
      errors: {},
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 15,
        totalItems: 0
      },
      branchIndex: -1,
      areaIndex: -1,
      projectIndex: -1,
      userIndex: -1,
      categoryIndex: -1,
      editedBranch: {
        company: {
          id: null
        },
        branch_name: '',
        street: '',
        city: '',
        state: '',
        sat_pais_id: '',
        zip_code: ''
      },
      defaultBranch: {
        company: {
          id: null
        },
        branch_name: '',
        street: '',
        city: '',
        state: '',
        sat_pais_id: '',
        zip_code: ''
      },
      editedArea: {
        company_id: '',
        name: ''
      },
      defaultArea: {
        company_id: '',
        name: ''
      },
      editedProject: {
        company_id: '',
        name: ''
      },
      defaultProject: {
        company_id: '',
        name: ''
      },
      editedUser: {
        id: null,
        name: '',
        email: '',
        email_original: '',
        password: '',
        user_info: {
          phone: '',
          address: '',
          sat_pais_id: '',
          avatar: '',
          gender: '',
          birthdate: '',
          branch_id: null
        },
        company: [
          {
            id: null
          }
        ],
        roles: [],
        area: [],
        application: null
      },
      defaultUser: {
        id: null,
        name: '',
        email: '',
        email_original: '',
        password: '',
        user_info: {
          phone: '',
          address: '',
          sat_pais_id: '',
          avatar: '',
          gender: '',
          birthdate: '',
          branch_id: null
        },
        company: [
          {
            id: null
          }
        ],
        roles: [],
        area: [],
        application: null
      },
      editedCategory: {
        id: 0,
        name: '',
        company_id: 0,
        default: 0
      },
      defaultCategory: {
        id: 0,
        name: '',
        company_id: 0,
        default: 0
      },
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', { size: '5', unit: 'MB' }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png',
        maxFiles: 1,
        headers: { 'Authorization': 'Bearer ' + this.$store.state.userState.access_token },
        params: {
          'dirname': 'USER_AVATAR',
          'is_public': 1,
          'user_id': this.$store.state.userLogged.id
        }
      },
      settings: [],
      periodsType: [],
      settingType: [],
      periodDialog: false,
      valid: true,
      editedIndexPeriod: -1,
      editedItemPeriod: {
        company_id: 0,
        gst_setting_type_id: 0,
        value: {
          periodType: '',
          deadline: ''
        },
        value_expenseComment: {
          fiscal: {
            comment_required: null
          },
          no_fiscal: {
            comment_required: null
          }
        },
        original: null
      },
      defaultItemPeriod: {
        company_id: 0,
        gst_setting_type_id: 0,
        value: {
          periodType: '',
          deadline: ''
        },
        value_expenseComment: {
          fiscal: {
            comment_required: null
          },
          no_fiscal: {
            comment_required: null
          }
        },
        original: null
      },
      monthDays: [
        {id: 1, name: '1'},
        {id: 2, name: '2'},
        {id: 3, name: '3'},
        {id: 4, name: '4'},
        {id: 5, name: '5'},
        {id: 6, name: '6'},
        {id: 7, name: '7'},
        {id: 8, name: '8'},
        {id: 9, name: '9'},
        {id: 10, name: '10'},
        {id: 11, name: '11'},
        {id: 12, name: '12'},
        {id: 13, name: '13'},
        {id: 14, name: '14'},
        {id: 15, name: '15'},
        {id: 16, name: '16'},
        {id: 17, name: '17'},
        {id: 18, name: '18'},
        {id: 19, name: '19'},
        {id: 20, name: '20'},
        {id: 21, name: '21'},
        {id: 22, name: '22'},
        {id: 23, name: '23'},
        {id: 24, name: '24'},
        {id: 25, name: '25'},
        {id: 26, name: '26'},
        {id: 27, name: '27'},
        {id: 28, name: '28'},
        {id: 29, name: '29'},
        {id: 30, name: '30'},
        {id: 31, name: '31'}
      ]
    }
  },
  computed: {
    headersB () {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'branch_name',
          sortable: true
        },
        {
          text: this.$t('address.street'),
          align: 'center',
          value: 'street',
          sortable: true
        },
        {
          text: this.$t('address.city'),
          align: 'center',
          value: 'city',
          sortable: true
        },
        {
          text: this.$t('address.state'),
          align: 'center',
          value: 'state',
          sortable: true
        },
        {
          text: this.$t('address.country'),
          align: 'center',
          value: 'country',
          sortable: true
        },
        {
          text: this.$t('address.zip'),
          align: 'center',
          value: 'zip_code',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    headersA () {
      return [
        {
          text: '#',
          align: 'center',
          sortable: false
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    headersP () {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    headersU () {
      return [
        {
          text: '#',
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('general.name'),
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: this.$t('general.email'),
          align: 'left',
          sortable: true,
          value: 'email'
        },
        {
          text: this.$t('role.name'),
          align: 'left',
          sortable: true,
          value: 'roles[0].name'
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'name',
          sortable: false
        }
      ]
    },
    headersPeriod () {
      return [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('setting.type'),
          align: 'center',
          value: 'gst_setting_type_id',
          sortable: true
        },
        {
          text: this.$t('setting.value'),
          align: 'center',
          value: 'value',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    headersC () {
      return [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    branchTitle () {
      return this.branchIndex === -1 ? this.$t('branch.add') : this.$t('branch.edit')
    },
    areaTitle () {
      return this.areaIndex === -1 ? this.$t('area.add') : this.$t('area.edit')
    },
    projectTitle () {
      return this.projectIndex === -1 ? this.$t('project.add') : this.$t('project.edit')
    },
    userTitle () {
      return this.userIndex === -1 ? this.$t('user.add') : this.$t('user.edit')
    },
    categoryTitle () {
      return this.categoryIndex === -1 ? this.$t('categories.add') : this.$t('categories.edit')
    },
    editingItem () {
      return this.editedIndex !== -1
    },
    isNewItem () {
      return this.editedIndex === -1
    },
    rules () {
      return this.$validationRules()
    },
    rolFilter () {
      return this.roles.slice(1)
    },
    dataArrayFilter () {
      return this.$searchCountry()
    },
    weekDays () {
      return [
        {id: 1, name: this.$t('settings.weekDays.sunday')},
        {id: 2, name: this.$t('settings.weekDays.monday')},
        {id: 3, name: this.$t('settings.weekDays.tuesday')},
        {id: 4, name: this.$t('settings.weekDays.wednesday')},
        {id: 5, name: this.$t('settings.weekDays.thursday')},
        {id: 6, name: this.$t('settings.weekDays.friday')},
        {id: 7, name: this.$t('settings.weekDays.saturday')}
      ]
    },
    companySettings () {
      if (this.userLogged.company !== undefined) {
        return this.settings.filter(item => item.company_id === this.userLogged.company[0].id)
      }
    },
    formTitle () {
      return this.editedIndexPeriod === -1 ? this.$t('setting.add') : this.$t('setting.edit')
    },
    days () {
      if (this.editedItemPeriod.value.periodType === 1) {
        return this.weekDays
      } else {
        return this.monthDays
      }
    },
    periodLabel () {
      if (this.editedItemPeriod.value.periodType === 1) {
        return this.$t('setting.weekly')
      } else if (this.editedItemPeriod.value.periodType === 2) {
        return this.$t('setting.biweekly')
      } else if (this.editedItemPeriod.value.periodType === 3) {
        return this.$t('setting.monthly')
      } else {
        return this.$t('setting.weekly')
      }
    }
  },
  watch: {
    '$store.state.userLogged' () {
      if (this.$store.state.userLogged.company !== undefined) {
        this.userLogged = this.$store.state.userLogged
        this.get()
      }
    },
    userLogged () {
      if (this.userLogged.company !== undefined) {
        this.get()
      } else {
        this.userLogged = this.$store.state.userLogged
      }
    },
    searchB (val) {
      this.querySelection(val)
      this.dataArrayFilter.search(this.editedBranch.sat_pais_id, val)
    },
    searchU (val) {
      this.querySelection(val)
      this.dataArrayFilter.search(this.editedUser.country, val)
    },
    branchesByCompany () {
      this.branches = Object.assign({}, this.branchesByCompany)
    },
    categories () {
      if (this.categories.length > 0) {
        this.defaultsLoaded = true
        if (this.categories.find(item => item.default === 1)) {
          this.noDefault = false
        } else {
          this.noDefault = true
        }
      }
    }
  },
  created () {
    this.get()
    if (this.$store.state.userLogged.company !== undefined) {
      this.userLogged = this.$store.state.userLogged
    }
  },
  methods: {
    saveBranch () {
      if (this.$refs.branchForm.validate()) {
        this.loading = true
        this.editedBranch.company.id = this.userLogged.company !== undefined ? this.userLogged.company[0].id : this.$store.state.userLogged.company[0].id
        if (this.branchIndex > -1) {
          this.$store.dispatch('branches/put', {event: {item: this.editedBranch, index: this.branchIndex, context: this}})
        } else {
          this.$store.dispatch('branches/post', {event: {item: this.editedBranch, context: this}})
        }
      }
    },
    saveArea () {
      if (this.$refs.areaForm.validate()) {
        this.loading = true
        this.editedArea.company_id = this.userLogged.company !== undefined ? this.userLogged.company[0].id : this.$store.state.userLogged.company[0].id
        if (this.areaIndex > -1) {
          this.$store.dispatch('areas/put_areas', {
            event: {
              item: this.editedArea,
              index: this.areaIndex,
              context: this
            }
          })
        } else {
          this.$store.dispatch('areas/post_areas', {
            event: {
              name: this.editedArea.name,
              company_id: this.editedArea.company_id,
              context: this
            }
          })
        }
      }
    },
    saveProject () {
      if (this.$refs.projectForm.validate()) {
        this.loading = true
        this.editedProject.company_id = this.userLogged.company !== undefined ? this.userLogged.company[0].id : this.$store.state.userLogged.company[0].id
        if (this.projectIndex > -1) {
          this.$store.dispatch('projects/project_put', {
            event: {
              item: this.editedProject,
              index: this.projectIndex,
              context: this
            }})
        } else {
          this.$store.dispatch('projects/project_post', {
            event: {
              name: this.editedProject.name,
              company: this.userLogged.company !== undefined ? this.userLogged.company[0].id : this.$store.state.userLogged.company[0].id,
              context: this
            }
          })
        }
      }
    },
    saveCategory () {
      if (this.$refs.categoryForm.validate()) {
        if (this.categoryIndex > -1) {
          this.$store.dispatch('categories/put', {event: {item: this.editedCategory, index: this.categoryIndex, context: this}})
        } else {
          this.$store.dispatch('categories/post', {event: {item: this.editedCategory, context: this}})
        }
        this.loading = true
      }
    },
    saveUser () {
      if (this.$refs.userForm.validate()) {
        this.loading = true
        this.editedUser.company[0].id = this.userLogged.company !== undefined ? this.userLogged.company[0].id : this.$store.state.userLogged.company[0].id
        if (this.userIndex > -1) {
          this.$store.dispatch('users/put', {
            event: {
              item: this.editedUser,
              index: this.userIndex,
              avatar: this.avatarId,
              context: this
            }
          })
        } else {
          this.$store.dispatch('users/post', {
            event: {
              item: this.editedUser,
              context: this
            }
          })
        }
      }
    },
    editBranch (item) {
      this.branchIndex = this.branches.indexOf(item)
      this.editedBranch = Object.assign({}, JSON.parse(JSON.stringify(item)))
      if (this.editedBranch.pivot !== undefined) {
        this.editedBranch.company = {id: this.editedBranch.pivot.company_id}
      }
      this.branchDialog = true
    },
    editArea (item) {
      this.areaIndex = this.areas.indexOf(item)
      this.editedArea = Object.assign({}, item)
      this.areaDialog = true
    },
    editProject (item) {
      this.projectIndex = this.projects.indexOf(item)
      this.editedProject = Object.assign({}, item)
      this.projectDialog = true
    },
    editCategory (item) {
      this.categoryIndex = this.categories.indexOf(item)
      this.editedCategory = Object.assign({}, item)
      this.categoryDialog = true
    },
    editUser (item) {
      if (item.user_info.avatar) {
        this.avatarUrl = item.user_info.avatar.public_url
      }
      this.userIndex = this.users.indexOf(item)
      this.editedUser = Object.assign({}, item)
      if (this.editedUser.user_info.sat_pais_id) {
        this.items.push(this.editedUser.user_info.sat_pais_id)
      }
      this.userDialog = true
    },
    closeBranch () {
      this.branchDialog = false
      this.editedBranch = Object.assign({}, this.defaultBranch)
      this.$refs.branchForm.resetValidation()
      this.branchIndex = -1
      this.loading = false
    },
    closeArea () {
      this.areaDialog = false
      this.editedArea = Object.assign({}, this.defaultArea)
      this.$refs.areaForm.resetValidation()
      this.areaIndex = -1
      this.loading = false
    },
    closeProject () {
      this.projectDialog = false
      this.editedProject = Object.assign({}, this.defaultProject)
      this.$refs.projectForm.resetValidation()
      this.projectIndex = -1
      this.loading = false
    },
    closeCategory () {
      this.categoryDialog = false
      this.loading = false
      this.errors = {}
      this.editedCategory = Object.assign({}, this.defaultCategory)
      this.categoryIndex = -1
      this.$refs.categoryForm.resetValidation()
    },
    closeUser () {
      this.userDialog = false
      this.avatarUrl = null
      this.avatarId = null
      this.editedUser = Object.assign({}, JSON.parse(JSON.stringify(this.defaultUser)))
      this.$refs.userForm.resetValidation()
      if (this.$refs.dropzone !== undefined) {
        this.$refs.dropzone.removeAllFiles()
      }
      this.userIndex = -1
      this.loading = false
    },
    fileAdded (file) {
      let fileType = file.type
      if (fileType === 'image/jpeg') {
        this.dropzoneOptions.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
      }
    },
    fileUploadError (file, message, xhr) {
      this.showNotification(message, 'error', -1)
    },
    fileUpload (file, response) {
      this.editedUser.user_info.avatar = response.data.id
      this.avatarId = response.data.id
    },
    changeSort (header) {
      if (header.sortable) {
        if (this.pagination.sortBy === header.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.descending = false
        }
        this.pagination.sortBy = header.value
      } else {
        this.pagination.sortBy = ''
      }
    },
    onComplete () {
      this.$store.dispatch('wizard/endWizard', {event: {context: this}})
    },
    get () {
      this.$emit('wizardGet', {context: this})
    },
    getUsers () {
      this.$store.dispatch('wizard/getUsers', {event: {context: this}})
      return true
    },
    querySelection (val) {
      this.items = this.dataArrayFilter.querySelection(this.satPais, val)
    },
    close () {
      this.closeBranch()
      this.closeArea()
      this.closeProject()
      this.closeUser()
      this.closePeriod()
      this.closeCategory()
    },
    setCategoriesDefault () {
      this.loading = true
      this.$store.dispatch('categories/setDefaults', {event: {context: this}})
    },
    refresh () {
      this.$store.dispatch('wizard/getUsers', {event: {context: this}})
      this.$store.dispatch('settings/setting_get', {event: {context: this}})
    },
    getPeriodType (id) {
      if (this.periodsType.length >= 1) {
        return this.periodsType.find(item => item.id === id).name
      }
    },
    getWeekDay (id) {
      return this.weekDays.find(item => item.id === id).name
    },
    savePeriod () {
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.editedIndexPeriod > -1) {
          this.putPeriod()
        } else {
          this.postPeriod()
        }
      }
    },
    postPeriod () {
      let item = {
        company_id: this.editedItemPeriod.company_id = this.userLogged.company !== undefined ? this.userLogged.company[0].id : this.$store.state.userLogged.company[0].id,
        gst_setting_type_id: this.editedItemPeriod.gst_setting_type_id,
        value: null
      }
      if (this.editedItemPeriod.gst_setting_type_id === 1) {
        item.value = JSON.stringify(this.editedItemPeriod.value)
      } else {
        item.value = JSON.stringify(this.editedItemPeriod.value_expenseComment)
      }
      this.$store.dispatch('settings/setting_post', {
        event: {
          item: item,
          context: this
        }
      })
    },
    putPeriod () {
      let item = {
        company_id: this.editedItemPeriod.company_id = this.userLogged.company !== undefined ? this.userLogged.company[0].id : this.$store.state.userLogged.company[0].id,
        gst_setting_type_id: this.editedItemPeriod.gst_setting_type_id,
        value: null
      }
      if (this.editedItemPeriod.setting_type.id === 1) {
        item.value = JSON.stringify(this.editedItemPeriod.value)
      } else {
        item.value = JSON.stringify(this.editedItemPeriod.value_expenseComment)
      }
      this.$store.dispatch('settings/setting_put', {
        event: {
          item: item,
          id: this.editedItemPeriod.id,
          context: this
        }
      })
    },
    editedPeriod (item) {
      this.editedIndexPeriod = this.settings.indexOf(item)
      let setting = Object.assign({}, JSON.parse(JSON.stringify(item.value)))
      this.editedItemPeriod = Object.assign({}, JSON.parse(JSON.stringify(item)))
      this.editedItemPeriod.value_expenseComment = setting
      this.editedItemPeriod.original = item.value
      this.periodDialog = true
    },
    closePeriod () {
      this.periodDialog = false
      this.editedItemPeriod = Object.assign({}, this.defaultItemPeriod)
      this.editedIndexPeriod = -1
      this.$refs.form.resetValidation()
    },
    refreshPeriod () {
      this.$store.dispatch('settings/setting_get', { event: { context: this } })
    },
    getCategories () {
      this.$store.dispatch('categories/get', {event: { context: this }})
    },
    initialize () {
      this.$store.dispatch('categories/get', {event: { context: this }})
    }
  }
}
</script>
<style scoped>
  .wizard-btn {
    padding-top: 30px !important;
    padding-bottom: 30px !important
  }
</style>



// WEBPACK FOOTER //
// src/components/wizard.component.vue